import { render, staticRenderFns } from "./tabsIndex.vue?vue&type=template&id=6dc3afa0&scoped=true"
import script from "./tabsIndex.vue?vue&type=script&lang=js"
export * from "./tabsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc3afa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc3afa0')) {
      api.createRecord('6dc3afa0', component.options)
    } else {
      api.reload('6dc3afa0', component.options)
    }
    module.hot.accept("./tabsIndex.vue?vue&type=template&id=6dc3afa0&scoped=true", function () {
      api.rerender('6dc3afa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/falseSignDailyReport/tabsIndex.vue"
export default component.exports